<template>
  <div class="box">
    <share></share>
    <img :src="img" alt="" srcset="">
  </div>
</template>
 
<script>
import data from "@/assets/data.js"
import share from "./share"

export default {
  name: 'posterDetail',
  components: {
    share,
  },
  data () {
    return {
      data,
      img: '',
    }
  },
  beforeRouteUpdate(to, from, next) {
    let id = to.params.id
    this.fetch(id)
    next();
  },
  mounted () {
    let id = this.$route.params.id;
    this.fetch(id)
  },
  methods: {
    fetch(id){
      let that = this;
      this.data.forEach(item => {
        if(item.id == id){
          var ua = navigator.userAgent.toLowerCase();
          if(ua.match(/MicroMessenger/i)=="micromessenger") {
            //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
            wx.miniProgram.getEnv((res)=>{
              if (res.miniprogram) {
                that.img = item.img3
                // alert("在小程序里");
              } else {
                that.img = item.img4
                // alert("在微信内置浏览器内");
              }
            })
          }else{
            that.img = item.img4
            console.log('不在微信里');
          }
          
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.box{
  img{
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/poster.vue